export default "__VITE_ASSET__685648be__"